import { useLocation } from "react-router-dom";
import cx from "classnames";

import Tooltip from "ds/components/Tooltip";
import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import { SidebarNavigationItemRule } from "types/Navigation";
import BaseActionButton from "ds/components/BaseAction/Button";
import Icon from "ds/components/Icon";
import { ChevronRight, Dots } from "components/icons/generated";

import { checkIsActive } from "./helpers";
import MenuItemText from "./MenuItemText";
import FadeTransition from "./FadeTransition";
import styles from "./styles.module.css";

type MoreFeaturesMenuItemProps = {
  short: boolean;
  rule?: SidebarNavigationItemRule;
  tooltipDisabled?: boolean;
  className?: string;
  beta?: boolean;
};

const MoreFeaturesMenuItem = ({
  short,
  rule,
  tooltipDisabled,
  className,
  beta,
}: MoreFeaturesMenuItemProps) => {
  const location = useLocation();
  const isActive = checkIsActive(location.pathname, rule);

  const content = (
    <Box justify="between" grow="1" gap="small" align="center">
      More features
      {!short && <Icon src={ChevronRight} />}
    </Box>
  );

  return (
    <Tooltip
      disableAriaLabel
      active={short && !tooltipDisabled}
      placement="right"
      on={(props) => (
        <BaseActionButton
          {...props}
          fullWidth
          className={cx(className, styles.menuItem, { [styles.menuItemActive]: isActive })}
          aria-label="More features"
        >
          <Icon src={Dots} size="large" noShrink />
          <FadeTransition visible={!short}>
            {beta ? (
              <Box gap="medium" align="center">
                <MenuItemText>{content}</MenuItemText>
                <BadgeNext variant="blue" text="BETA" type="strong" />
              </Box>
            ) : (
              <MenuItemText>{content}</MenuItemText>
            )}
          </FadeTransition>
        </BaseActionButton>
      )}
    >
      {content}
    </Tooltip>
  );
};

export default MoreFeaturesMenuItem;
